// SL.L1a-2 (#2957, ruling 11) — the one small confirmation the board's sprint
// actions share (approve, return to draft, start, plain close). Built on
// SlideOver for its focus trap, Escape, focus restore and role="dialog"; never
// window.confirm.
import type { CSSProperties, ReactNode } from 'react';
import SlideOver from '../SlideOver';

export const dialogButton: CSSProperties = {
  padding: '8px 16px', borderRadius: 'var(--radius-md)', border: '1px solid var(--border)',
  background: 'var(--surface)', color: 'var(--text)', fontFamily: 'var(--font-body)', fontSize: 13, fontWeight: 600, cursor: 'pointer',
};
export const primaryButton: CSSProperties = { ...dialogButton, border: 'none', background: 'var(--primary)', color: '#fff' };

export function DialogFooter({ children }: { children: ReactNode }) {
  return <div style={{ display: 'flex', gap: 'var(--space-2)', justifyContent: 'flex-end' }}>{children}</div>;
}

export default function SprintConfirmDialog({ title, message, confirmLabel, busy, onConfirm, onCancel }: {
  title: string;
  message: string;
  confirmLabel: string;
  /** The request is in flight: the confirm button is disabled, so it is sent once. */
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <SlideOver
      isOpen
      onClose={onCancel}
      title={title}
      width="sm"
      footer={(
        <DialogFooter>
          <button type="button" onClick={onCancel} style={dialogButton}>Cancel</button>
          <button type="button" onClick={onConfirm} disabled={busy} style={{ ...primaryButton, opacity: busy ? 0.7 : 1, cursor: busy ? 'wait' : 'pointer' }}>
            {confirmLabel}
          </button>
        </DialogFooter>
      )}
    >
      <p style={{ fontFamily: 'var(--font-body)', fontSize: 14, color: 'var(--text)', margin: 0 }}>{message}</p>
    </SlideOver>
  );
}
